import styled from 'styled-components';
import { prop } from 'styled-tools';
import { media } from '@sizeid/commons/utils/styles';

export default styled.img`
  height: ${prop('height', '80px')};
  max-width: 100%;
  margin: 0 auto;

  p + & {
    margin-top: 50px;
  }

  ${media.lessThan('sm')`
    height: auto;
  `};
`;
